import { render, staticRenderFns } from "./HotelsListItem.vue?vue&type=template&id=4fe53312"
import script from "./HotelsListItem.vue?vue&type=script&lang=js"
export * from "./HotelsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotelsCarousel: require('/home/forge/ab.farescraper.com/components/HotelsCarousel.vue').default,IconsHotel: require('/home/forge/ab.farescraper.com/components/IconsHotel.vue').default,DropdownPartnerItem: require('/home/forge/ab.farescraper.com/components/DropdownPartnerItem.vue').default})
